class EtUsProduct {
    constructor(sectionId, data) {
        this.sectionId = sectionId;
        this.data = data;
        this.selectedColorIndex = 0;
        this.selectedSize = null;
        this.currencySymbol = this.data.settings.currency_symbol || '€';

        this.section = document.getElementById('et-us-product-' + sectionId);
        if (!this.section) return;

        this.gallery = document.getElementById('et-us-gallery-' + sectionId);
        this.sizeSelector = document.getElementById('et-us-size-options-' + sectionId);
        this.swatchesContainer = document.getElementById('et-us-swatches-' + sectionId);
        this.swatchesSwiperContainer = document.getElementById('et-us-swatches-swiper-' + sectionId);
        this.swatchSwiper = null;
        this.atcBtn = document.getElementById('et-us-atc-btn-' + sectionId);

        this.modal = document.getElementById('et-us-modal-' + sectionId);
        this.modalCloseBtn = document.getElementById('et-us-modal-close-' + sectionId);
        this.modalWrapper = document.getElementById('et-us-modal-wrapper-' + sectionId);
        this.modalSwiperContainer = document.getElementById('et-us-modal-swiper-' + sectionId);
        this.modalSwiper = null;

        this.init();
    }

    init() {
        var self = this;
        this.renderSizes();
        this.renderSwatches();
        this.updateGallery();
        this.updatePrices();
        this.updateATC();

        var autoSize = this.data.settings.preselected_size;
        if (autoSize) {
            this.selectSize(autoSize);
        }

        if (this.atcBtn) {
            this.atcBtn.addEventListener('click', function () { self.handleAddToCart(); });
        }

        if (this.gallery) {
            this.gallery.addEventListener('click', function (e) {
                if (window.innerWidth >= 1024) return;
                var target = e.target;
                if (target.tagName === 'IMG' && target.closest('.et-us-product__image-item')) {
                    var idx = parseInt(target.dataset.index);
                    if (!isNaN(idx)) self.openModal(idx);
                }
            });
        }

        var zoomBtn = document.getElementById('et-us-zoom-btn-' + this.sectionId);
        if (zoomBtn) {
            zoomBtn.addEventListener('click', function () { self.openModal(0); });
        }

        if (this.modalCloseBtn) {
            this.modalCloseBtn.addEventListener('click', function () { self.closeModal(); });
        }

        var swatchNextBtn = document.getElementById('et-us-swatch-next-' + this.sectionId);
        if (swatchNextBtn) {
            swatchNextBtn.addEventListener('click', function () { self.scrollSwatches(1); });
        }
    }

    getProducts() {
        return this.data.products || [];
    }

    getSelectedProduct() {
        var products = this.getProducts();
        return products[this.selectedColorIndex] || null;
    }

    renderSizes() {
        if (!this.sizeSelector) return;
        var products = this.getProducts();
        if (!products.length) return;

        var product = products[0];
        if (!product || !product.variants) return;

        var self = this;
        var sizes = [];
        var seen = {};
        product.variants.forEach(function (v) {
            var size = v.title.split(' / ')[0];
            if (!seen[size]) {
                seen[size] = true;
                sizes.push(size);
            }
        });

        if (!this.selectedSize && sizes.length > 0) {
            this.selectedSize = sizes[0];
        }

        var sizeLabel = document.getElementById('et-us-selected-size-' + this.sectionId);
        if (sizeLabel && this.selectedSize) {
            sizeLabel.textContent = this.selectedSize;
        }

        this.sizeSelector.innerHTML = sizes.map(function (size) {
            var isActive = self.selectedSize === size ? 'active' : '';
            return '<button type="button" class="et-us-product__size-option ' + isActive + '" data-size="' + size + '">' + size + '</button>';
        }).join('');

        var opts = this.sizeSelector.querySelectorAll('.et-us-product__size-option');
        opts.forEach(function (opt) {
            opt.addEventListener('click', function () {
                self.selectSize(this.dataset.size);
            });
        });
    }

    selectSize(size) {
        this.selectedSize = size;

        var sizeLabel = document.getElementById('et-us-selected-size-' + this.sectionId);
        if (sizeLabel) sizeLabel.textContent = size;

        var sizeOptions = this.section.querySelectorAll('.et-us-product__size-option');
        var currentSize = this.selectedSize;
        sizeOptions.forEach(function (opt) {
            if (opt.dataset.size === currentSize) opt.classList.add('active');
            else opt.classList.remove('active');
        });

        this.updateSoldOutState();
        this.updatePrices();
        this.updateATC();
    }

    renderSwatches() {
        if (!this.swatchesContainer) return;
        var products = this.getProducts();
        if (!products.length) return;
        var self = this;

        var html = products.map(function (product, i) {
            var img = (product.metafields && product.metafields.color_image) ? product.metafields.color_image : product.featured_image;
            var isActive = i === self.selectedColorIndex ? ' active' : '';
            return '<div class="swiper-slide"><div class="et-us-product__swatch' + isActive + '" data-index="' + i + '">' +
                '<img src="' + img + '" alt="' + product.title + '">' +
                '</div></div>';
        }).join('');

        this.swatchesContainer.innerHTML = html;

        var colorLabel = document.getElementById('et-us-selected-color-' + this.sectionId);
        if (colorLabel && products[this.selectedColorIndex]) {
            colorLabel.textContent = products[this.selectedColorIndex].color_name || products[this.selectedColorIndex].title;
        }

        var swatches = this.swatchesContainer.querySelectorAll('.et-us-product__swatch');
        swatches.forEach(function (swatch) {
            swatch.addEventListener('click', function () {
                var idx = parseInt(this.dataset.index);
                if (!isNaN(idx)) self.selectColor(idx);
            });
        });

        this.initSwatchSwiper();
    }

    initSwatchSwiper() {
        if (this.swatchSwiper) {
            this.swatchSwiper.destroy(true, true);
            this.swatchSwiper = null;
        }
        if (!this.swatchesSwiperContainer || typeof Swiper === 'undefined') return;

        var self = this;
        this.swatchSwiper = new Swiper(this.swatchesSwiperContainer, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            freeMode: true,
            watchOverflow: true,
            navigation: {
                nextEl: '#et-us-swatch-next-' + this.sectionId
            }
        });
    }

    selectColor(index) {
        this.selectedColorIndex = index;

        var swatches = this.swatchesContainer.querySelectorAll('.et-us-product__swatch');
        swatches.forEach(function (s, i) {
            if (i === index) s.classList.add('active');
            else s.classList.remove('active');
        });

        var products = this.getProducts();
        var colorLabel = document.getElementById('et-us-selected-color-' + this.sectionId);
        if (colorLabel && products[index]) {
            colorLabel.textContent = products[index].color_name || products[index].title;
        }

        this.updateGallery();
        this.updateSoldOutState();
        this.updatePrices();
        this.updateATC();
    }

    scrollSwatches(direction) {
        if (this.swatchSwiper) {
            if (direction > 0) this.swatchSwiper.slideNext();
            else this.swatchSwiper.slidePrev();
        }
    }

    updateGallery() {
        if (!this.gallery) return;
        var product = this.getSelectedProduct();
        if (!product) return;

        var images = (product.images || []).slice(0, 4);
        if (images.length === 0) {
            var placeholdersLeft = '<div class="et-us-product__image-placeholder"></div>'.repeat(3);
            this.gallery.innerHTML =
                '<div class="et-us-product__gallery-col-small">' + placeholdersLeft + '</div>' +
                '<div class="et-us-product__gallery-col-large"><div class="et-us-product__image-wrapper-large"><div class="et-us-product__image-placeholder"></div></div></div>';
            return;
        }

        var mainImage = images[0];
        var smallImages = images.slice(1);

        var smallHtml = smallImages.map(function (img, i) {
            var realIndex = i + 1;
            return '<div class="et-us-product__image-wrapper-small"><img src="' + img + '" class="et-us-product__image-item" data-index="' + realIndex + '" alt="Product"></div>';
        }).join('');

        var largeHtml = '<div class="et-us-product__image-wrapper-large"><img src="' + mainImage + '" class="et-us-product__image-item" data-index="0" alt="Product"></div>';

        this.gallery.innerHTML =
            '<div class="et-us-product__gallery-col-small">' + smallHtml + '</div>' +
            '<div class="et-us-product__gallery-col-large">' + largeHtml + '</div>';
    }

    updatePrices() {
        var product = this.getSelectedProduct();
        if (!product || !product.variants || !product.variants.length) return;

        var variant = this.findVariantBySize(product, this.selectedSize, false);
        if (!variant) variant = product.variants[0];

        var price = variant.price / 100;
        var comparePrice = variant.compare_at_price ? variant.compare_at_price / 100 : 0;

        var priceBeforeEl = document.getElementById('et-us-price-before-' + this.sectionId);
        var priceAfterEl = document.getElementById('et-us-price-after-' + this.sectionId);
        var perPieceEl = document.getElementById('et-us-per-piece-' + this.sectionId);
        var perPieceWrapper = document.getElementById('et-us-per-piece-wrapper-' + this.sectionId);

        if (priceBeforeEl) {
            if (comparePrice > 0 && comparePrice > price) {
                priceBeforeEl.style.display = 'inline';
                priceBeforeEl.textContent = this.formatPrice(comparePrice);
            } else {
                priceBeforeEl.style.display = 'none';
            }
        }

        if (priceAfterEl) {
            priceAfterEl.textContent = this.formatPrice(price);
        }

        if (perPieceEl && perPieceWrapper) {
            var perPieceText = this.data.settings.text_per_piece || 'per stuk';
            var packSize = product.pack_size || 1;
            var perPiecePrice = price / packSize;
            var formattedPiece = this.formatPrice(perPiecePrice);
            if (perPieceText.indexOf('[price]') !== -1) {
                perPieceEl.textContent = perPieceText.replace('[price]', formattedPiece);
            } else {
                perPieceEl.textContent = formattedPiece + ' / ' + perPieceText;
            }
            perPieceWrapper.style.display = 'flex';
        }
    }

    formatPrice(val) {
        return this.currencySymbol + val.toFixed(2).replace('.', ',');
    }

    updateATC() {
        if (!this.atcBtn) return;
        var text = '';
        var disabled = true;

        if (!this.selectedSize) {
            text = this.data.settings.text_select_size || 'Select Size';
            disabled = true;
        } else {
            var product = this.getSelectedProduct();
            if (product) {
                var variant = this.findVariantBySize(product, this.selectedSize, true);
                if (variant && variant.available) {
                    text = this.data.settings.text_add_to_cart || 'Add to Cart';
                    disabled = false;
                } else {
                    text = this.data.settings.text_sold_out || 'Sold Out';
                    disabled = true;
                }
            }
        }

        this.atcBtn.textContent = text;
        this.atcBtn.disabled = disabled;
    }

    handleAddToCart() {
        var self = this;
        var product = this.getSelectedProduct();
        if (!product) return;

        this.atcBtn.disabled = true;
        var originalText = this.atcBtn.textContent;
        this.atcBtn.textContent = this.data.settings.text_adding || 'Adding...';

        var variant = this.findVariantBySize(product, this.selectedSize, true);
        if (!variant || !variant.available) {
            alert(this.data.settings.text_sold_out || 'Sold Out');
            this.atcBtn.textContent = originalText;
            this.atcBtn.disabled = false;
            return;
        }

        var items = [{ id: variant.id, quantity: 1 }];

        fetch(window.Shopify.routes.root + 'cart/add.js?sections=variant-added', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(function (response) {
            return response.json().then(function (data) {
                return { ok: response.ok, data: data };
            });
        })
        .then(function (result) {
            if (result.ok) {
                self.atcBtn.textContent = self.data.settings.text_added || 'Added!';
                window.location.href = '/checkout';
            } else {
                alert('Error: ' + (result.data.description || result.data.message));
                self.atcBtn.textContent = originalText;
                self.atcBtn.disabled = false;
            }
        })
        .catch(function (e) {
            console.error('ET ATC Error:', e);
            alert(self.data.settings.text_alert_error || 'Network error.');
            self.atcBtn.textContent = originalText;
            self.atcBtn.disabled = false;
        });
    }

    findVariantBySize(product, size, strict) {
        if (!product || !product.variants || product.variants.length === 0) return null;
        if (!size) {
            if (strict) return null;
            for (var i = 0; i < product.variants.length; i++) {
                if (product.variants[i].available) return product.variants[i];
            }
            return product.variants[0];
        }
        for (var j = 0; j < product.variants.length; j++) {
            var parts = product.variants[j].title.split(' / ');
            for (var k = 0; k < parts.length; k++) {
                if (parts[k].trim().toLowerCase() === size.toLowerCase()) {
                    return product.variants[j];
                }
            }
        }
        if (strict) return null;
        return product.variants[0];
    }

    updateSoldOutState() {
        var products = this.getProducts();
        if (!products.length || !this.swatchesContainer) return;
        var self = this;

        var swatches = this.swatchesContainer.querySelectorAll('.et-us-product__swatch');
        swatches.forEach(function (swatch, i) {
            var product = products[i];
            if (!product) return;

            var isAvailable = false;
            var variant = self.findVariantBySize(product, self.selectedSize, true);

            if (variant && variant.available) {
                isAvailable = true;
            } else if (!self.selectedSize) {
                isAvailable = product.variants.some(function (v) { return v.available; });
            }

            if (isAvailable) {
                swatch.classList.remove('sold-out');
            } else {
                swatch.classList.add('sold-out');
            }
        });
    }

    openModal(startIndex) {
        if (!this.modal || !this.modalWrapper) return;
        var product = this.getSelectedProduct();
        if (!product || !product.images) return;

        var images = product.images;
        if (images.length === 0) return;

        this.modalWrapper.innerHTML = images.map(function (src) {
            return '<div class="swiper-slide"><img src="' + src + '"></div>';
        }).join('');

        this.modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';

        if (this.modalSwiper) {
            this.modalSwiper.destroy(true, true);
            this.modalSwiper = null;
        }

        if (typeof Swiper !== 'undefined') {
            this.modalSwiper = new Swiper(this.modalSwiperContainer, {
                slidesPerView: 1,
                spaceBetween: 20,
                initialSlide: startIndex || 0,
                // pagination: {
                //     el: '#et-us-modal-pagination-' + this.sectionId,
                //     type: 'bullets',
                //     clickable: true,
                //     dynamicBullets: true
                // },
                navigation: {
                    nextEl: '#et-us-modal-next-' + this.sectionId,
                    prevEl: '#et-us-modal-prev-' + this.sectionId,
                }
            });
        }
    }

    closeModal() {
        if (!this.modal) return;
        this.modal.style.display = 'none';
        document.body.style.overflow = '';
        if (this.modalSwiper) {
            this.modalSwiper.destroy(true, true);
            this.modalSwiper = null;
        }
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (!window.etUsProductData) return;
    var keys = Object.keys(window.etUsProductData);
    for (var i = 0; i < keys.length; i++) {
        var id = keys[i];
        var scName = 'et_us_' + id.replace(/-/g, '_');
        window[scName] = new EtUsProduct(id, window.etUsProductData[id]);
    }
});
